import { render, staticRenderFns } from "./ModalLayanan.vue?vue&type=template&id=222e544e&"
import script from "./ModalLayanan.vue?vue&type=script&lang=js&"
export * from "./ModalLayanan.vue?vue&type=script&lang=js&"
import style0 from "./ModalLayanan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports